<dx-box *ngIf="communities" width="100%" height="100%" direction="col" class="user-communities-map-container">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-toolbar width="100%">
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-select-box
                            width="100%"
                            displayExpr="displayText"
                            valueExpr="key"
                            [dataSource]="accessOptions"
                            [(value)]="filterParams.includeInactive"
                            (onValueChanged)="doRefresh()"
                        ></dx-select-box>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">User View:</div>
                        <div class="cc-field-value">
                            <app-multi-column-selector
                                [name]="'User View'"
                                [gridSource]="userList"
                                [boxValue]="[filterParams.userId]"
                                [valueExpr]="'userId'"
                                [displayExpr]="'name'"
                                [columnDef]="userColumns"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 'auto' }"
                                [showClearButton]="true"
                                [placeholder]="'Select User'"
                                (gridSelectionEvent)="onUserSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">Locations:</div>
                        <div class="cc-field-value">
                            <app-user-context-tree
                                [placeholder]="'Select Locations'"
                                [allowGlobalSelection]="false"
                                [allowManagementCompanySelection]="false"
                                [allowLocationSelection]="true"
                                [allowCommunitySelection]="false"
                                [showGlobalNode]="false"
                                [selectionMode]="'multiple'"
                                [showClearButton]="false"
                                (getContextTreeSelectedData)="onLocationsSelection($event)"
                            ></app-user-context-tree>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="before">
                    <div *dxTemplate class="cc-field">
                        <div class="cc-field-label">Communities:</div>
                        <div class="cc-field-value">
                            <app-user-context-tree
                                [placeholder]="'Select Communities'"
                                [allowGlobalSelection]="false"
                                [allowManagementCompanySelection]="false"
                                [allowLocationSelection]="false"
                                [showGlobalNode]="false"
                                [selectionMode]="'multiple'"
                                [showClearButton]="false"
                                (getContextTreeSelectedData)="onCommunitiesSelection($event)"
                            ></app-user-context-tree>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item location="after">
                    <div *dxTemplate>
                        <dx-button
                            type="default"
                            icon="refresh"
                            text="Refresh"
                            hint="Refresh"
                            (onClick)="doRefresh(true)"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate class="map-container dx-theme-border-color">
            <ng-container *ngIf="mapVisible">
                <input id="places-search" class="places-search-input" type="text" placeholder="Search Places" />
                <dx-map
                    width="100%"
                    height="100%"
                    provider="google"
                    type="hybrid"
                    [zoom]="17"
                    [controls]="true"
                    [center]="mapCenter"
                    [apiKey]="mapKeys"
                    (onReady)="onMapReady($event)"
                ></dx-map>
            </ng-container>
        </div>
    </dxi-item>
</dx-box>

<app-user-community-map-popover
    *ngIf="mapVisible"
    [isStreetView]="isStreetView"
    [selectedMarker]="selectedMarker"
    [selectedCommunity]="selectedCommunity"
></app-user-community-map-popover>
